<template>
  <div
    v-if="props.errorMessage && props.hasError"
    class="text-s error-message"
    :class="{ 'text-danger': !isWarning }"
  >
    <PflegeIcon :name="`${isWarning ? 'warning' : 'error'}-fill`" color="danger" size="l" />
    <span>{{ props.errorMessage }}</span>
  </div>
</template>

<script setup>
const props = defineProps({
  errorMessage: {
    type: String,
    default: ''
  },
  hasError: {
    type: Boolean,
    default: false
  },
  isWarning: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped>
.error-message {
  display: flex;
  align-items: start;
  gap: 0.5rem;
}
</style>
